module.exports = {"id":"213414","name":"William Troost-Ekong","rating":"72","photo":"./data/images/photos/4/213414.png","club":{"name":"Bursaspor","logo":"./data/images/clubs/Bursaspor.png"},"positions":["DC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/WilliamTroost-Ekong0.json
// module id = 4349
// module chunks = 0